"use strict";

(() => {
  var e,
    r,
    a,
    t = Object.getOwnPropertyNames,
    o = (e, r) =>
      function () {
        return e && (r = (0, e[t(e)[0]])((e = 0))), r;
      },
    s = o({
      "src/pattern.ts"() {
        e =
          " daum[ /]| deusu/| yadirectfetcher|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<![hg]m)score|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\btime/|^<|^[\\w \\.\\-\\(?:\\):]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[^ ]{50,}$|^\\d+\\b|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^active|^ad muncher|^amaya|^avsdevicesdk/|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/5\\.0\\s[a-z\\.-]+$|^mozilla/\\d\\.\\d \\(compatible;?\\)$|^mozilla/\\d\\.\\d \\w*$|^navermailapp|^netsurf|^offline|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^valid|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|^{{.*}}$|adscanner/|analyzer|archive|ask jeeves/teoma|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|evc-batch/|exaleadcloudview|feed|firephp|functionize|gomezagent|headless|httrack|hubspot marketing grader|hydra|ibisbrowser|images|infrawatch|insight|inspect|iplabel|ips-agent|java(?!;)|jsjcw_scanner|library|linkcheck|mail\\.ru/|manager|measure|neustar wpm|node|nutch|offbyone|optimize|pageburst|pagespeed|parser|perl|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|reputation|resolver|retriever|rexx;|rigor|rss\\b|scanner\\.|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|trace|transcoder|url|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|zgrab";
      },
    });
  function c(t) {
    return (
      Boolean(t) &&
      (function () {
        if (a instanceof RegExp) return a;
        try {
          a = new RegExp(e, "i");
        } catch (e) {
          a = r;
        }
        return a;
      })().test(t)
    );
  }
  var i,
    n,
    l = o({
      "src/index.ts"() {
        s(), (r = /bot|crawl|http|lighthouse|scan|search|spider/i);
      },
    });
  ((i = {
    "src/browser.ts"() {
      l(),
        "object" != typeof globalThis
          ? "object" != typeof window
            ? "object" != typeof global
              ? "object" == typeof self && (self.isBot = c)
              : (global.isBot = c)
            : (window.isBot = c)
          : (globalThis.isBot = c);
    },
  }),
    function () {
      return n || (0, i[t(i)[0]])((n = { exports: {} }).exports, n), n.exports;
    })();
})();

/*
  Refer to the theme liquid code
*/

var startTime = Date.now();

var COOKIE_DOMAINS = [".myfrido.com"];
var AB_DEST_TECTONIC = "tectonic";
var AB_DEST_SHOPIFY = "shopify";

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "expires=".concat(date.toUTCString(), ";");
  }
  COOKIE_DOMAINS.forEach(function (cookieDomain) {
    var cookieStr = ""
      .concat(name, "=")
      .concat(encodeURIComponent(value || ""), "; ")
      .concat(expires, " domain=")
      .concat(cookieDomain, "; path=/;");
    document.cookie = cookieStr;
  });
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0)
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

function eraseCookie(name) {
  COOKIE_DOMAINS.forEach(function (cookieDomain) {
    var cookieStr = ""
      .concat(name, "=; domain=")
      .concat(cookieDomain, "; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;");
    document.cookie = cookieStr;
  });
}

var TECTONIC_SHOP_DOMAIN = "myfrido.com";
var SHOPIFY_SHOP_DOMAIN = "shop.myfrido.com";
var HEIMDALL_LOGGER_HOST = "tectonic-heimdall.pages.dev";
var AB_DESTS = new Set([AB_DEST_SHOPIFY, AB_DEST_TECTONIC]);

var SESSION_ID_TTL_DAYS = 1 / (24 * 2);
var REFERRER_TTL_DAYS = 1 / (24 * 6);

// [STICKINESS REMOVED] These cookie names are no longer read or written for routing.
// They are kept only so old values left in users' browsers can be cleaned up.
var AB_DEST_COOKIE_NAME = "_tt_ab_dest";
var AB_DEST_COOKIE_VERSION = "_tt_ab_dest_ver";
var AB_AD_DEST_COOKIE_NAME = "_tt_ab_ad_dest";
var AB_AD_DEST_COOKIE_VERSION = "_tt_ab_ad_dest_ver";
var TT_SESS_DEST = "__tt_heimdall_sess_dest";
var TT_SESS_TYPE = "__tt_heimdall_sess_type";
var TT_SESS_DEST_VERSION = "__tt_heimdall_sess_dest_ver";
var LEGACY_STICKY_COOKIES = [
  AB_DEST_COOKIE_NAME,
  AB_DEST_COOKIE_VERSION,
  AB_AD_DEST_COOKIE_NAME,
  AB_AD_DEST_COOKIE_VERSION,
  TT_SESS_DEST,
  TT_SESS_TYPE,
  TT_SESS_DEST_VERSION,
];

var TT_HERMES_DEVICE_ID_KEY = "__tt_hermes_device_id";
var TT_CLIENT_SESSION_ID_KEY = "__tt_hermes_client_session_id";
var TT_CLIENT_INSTANCE_ID_KEY = "__tt_hermes_client_instance_id";
var TT_SESSION_ID_KEY = "__tt_hermes_session_id";

var CID_COOKIE_NAME = "_tt_shopify_cid";
var TT_HEIMDALL_REFERRER = "__tt_heimdall_referrer";
var TT_SHOPIFY_B2B_REFERRER = "__tt_shopify_b2b_referrer";

var TT_DEBUG_DEST_PARAM = "tt_heimdall_debug_dest";
var SHOPIFY_THEME_EDITOR_PREVIEW_PARAM = "oseid";
var TT_HEIMDALL_ADMIN_TESTER_PARAM = "tt-heimdall-admin-tester";
var SHOPIFY_THEME_PREVIEW_ID_PARAM = "preview_theme_id";
var SHOPIFY_THEME_PREVIEW_KEY_PARAM = "preview_key";
var SHOPIFY_THEME_PREVIEW_HOST = "shopifypreview.com";
var SHOPIFY_USER_TOKEN_NAME = "_shopify_y";
var SHOPIFY_SESSION_TOKEN_NAME = "_shopify_s";

// below should be modified basis the needs
// threshold should be 1 - traffic%
var HEIMDALL_AB_CONFIG = {
  TEST_MODE: false,
  ROUTE_DESKTOP_TO_SHOPIFY: false,
  ROUTE_BOTS_TO_SHOPIFY: true,
  ROUTE_ADS_TO_SHOPIFY: false,
  TT_DEST_THRESH: 0.1,
  TT_AD_DEST_THRESH: 0.1,
  STICKY_ROUTING: false, // informational, for logs; routing is decided per page load
  CLEAR_LEGACY_STICKY_COOKIES: true, // erase old _tt_ab_* / __tt_heimdall_sess_* cookies
  CUTOVER_DONE: true,
  ORG: "frido",
  CONFIG_VERSION: 44,
  ROUTER_VERSION: 16,
};

var isABRoute = true

var TEST_USERS_LIST = new Set(["router-testing"]);

var SHOPIFY_ROUTES = new Set([
  "/pages/ergonomic-assistance",
  "/pages/frido-b2b-workspace",
  "/pages/frido-b2b-workspace-thank-you",
  "/pages/product-registration",
  "/pages/frido-cold-and-hot-therapy-cap-sale",
  "/pages/frido-five-toe-socks",
  "/pages/frido-maternity-pillow-plus",
  "/pages/frido-nasal-strip-pro",
  "/pages/frido-orthotics-toe-separator",
  "/pages/press-release",
  "/pages/affiliate",
  "/pages/campus",
  "/pages/affiliate-terms-and-condition",
  "/apps/return_prime",
  "/cdn/shop",
  "/cart.js",
  "/widget",
  "/api/redirect-hit",
  "/_t/c",
  "robots.txt",
  ".mp4",
  ".js",
  ".css",
  ".json",
  ".html",
  ".png",
  ".jpeg",
  ".jpg",
  ".webp",
  "sitemap"
]);

var TECTONIC_ALLOWED_PAGES = new Set([])

function isEmptyStr(value) {
  return (
    value == null || (typeof value === "string" && value.trim().length === 0)
  );
}

function matchesSymmetric(a, b) {
  var keysA = Object.keys(a),
    keysB = Object.keys(b);
  var keys = new Set([].concat(Object.keys(a), Object.keys(b)));
  if (keys.size !== keysA.length || keys.size !== keysB.length) return false;
  return Array.from(keys).every(
    (key) => a.hasOwnProperty(key) && b.hasOwnProperty(key) && a[key] === b[key]
  );
}

function objGetOrDefault(obj, key, defaultVal) {
  if (!(typeof obj === 'object' && obj !== null)) {
    return null
  }
  if (obj.hasOwnProperty(key)) {
    return obj[key]
  } else {
    return defaultVal ?? null
  }
}

var logDetails = {
  config: {
    testMode: HEIMDALL_AB_CONFIG.TEST_MODE,
    destThreshold: HEIMDALL_AB_CONFIG.TT_DEST_THRESH,
    adDestThreshold: HEIMDALL_AB_CONFIG.TT_AD_DEST_THRESH,
    stickyRouting: HEIMDALL_AB_CONFIG.STICKY_ROUTING,
    clearLegacyStickyCookies: HEIMDALL_AB_CONFIG.CLEAR_LEGACY_STICKY_COOKIES,
    routeDesktopToShopify: HEIMDALL_AB_CONFIG.ROUTE_DESKTOP_TO_SHOPIFY,
    routeBotsToShopify: HEIMDALL_AB_CONFIG.ROUTE_BOTS_TO_SHOPIFY,
    routeAdsToShopify: HEIMDALL_AB_CONFIG.ROUTE_ADS_TO_SHOPIFY,
    isCutOverDone: HEIMDALL_AB_CONFIG.CUTOVER_DONE,
    org: HEIMDALL_AB_CONFIG.ORG,
    configVersion: HEIMDALL_AB_CONFIG.CONFIG_VERSION,
    routerVersion: HEIMDALL_AB_CONFIG.ROUTER_VERSION,
  },
  input: {},
  state: {},
  output: {},
};

var globalProps = {
  referrer: document.referrer || "",
};

var currentUrl = window.location.href || "";
var currentUrlParams = window.location.search;

var debugDestination = "";
var isThemePreview = false;
var heimdallErr = null;
var isErrored = false;
var execTime = null;
var sendImmediately = false;
var isB2BReferrer = false;
var isAdminTester = false;
var shopifySession = getCookie(SHOPIFY_SESSION_TOKEN_NAME)
var shopifyUser = getCookie(SHOPIFY_USER_TOKEN_NAME)


function checkIfMobile(userAgent) {
  return (
    /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(userAgent) ||
    /\b(Android|Windows Phone|iPad|iPod)\b/i.test(userAgent)
  );
}

function checkIfSocialBrowser(userAgent) {
  return (
    !isEmptyStr(userAgent) &&
    (userAgent.toLowerCase().indexOf("fbav") !== -1 ||
      userAgent.toLowerCase().indexOf("fban") !== -1 ||
      userAgent.toLowerCase().indexOf("fbios") !== -1 ||
      userAgent.toLowerCase().indexOf("fb_iab") !== -1 ||
      userAgent.toLowerCase().indexOf("instagram") !== -1)
  );
}

function generateRandomId() {
  return (
    Math.random().toString(36).substring(2, 16) +
    Math.random().toString(36).substring(2, 16)
  );
}

var _sending = false;
var _deferSendTimer = null;

// we an an internal _id to each event object in the format upoc-counter
// this makes it easier for us to remove successfully sent event from local db
var _internalEventIdPrefix = new Date().getTime();
var _internalEventIdCounter = 0;

var transactions = {
  _key: "tt-heimdall-logger",

  // maximum number of items allowed before we start dropping first items
  _maxLength: 100,

  // returns a list of all transactions or empty array
  all: function () {
    return JSON.parse(localStorage.getItem(transactions._key) || "[]");
  },

  // adds an item to the transaction log
  add: function (data) {
    var existing = transactions.all();
    _internalEventIdCounter++;
    data._id = _internalEventIdPrefix + "-" + _internalEventIdCounter;
    if (existing.length + 1 > transactions._maxLength) {
      existing.shift();
    }
    existing.push(data);
    localStorage.setItem(transactions._key, JSON.stringify(existing));
  },

  // removes events from the transaction log
  remove: function (itemsToRemove) {
    var idsToRemove = (itemsToRemove || []).map(function (item) {
      return item._id;
    });
    var remaining = transactions.all().filter(function (item) {
      return idsToRemove.indexOf(item._id) === -1;
    });
    localStorage.setItem(transactions._key, JSON.stringify(remaining));
  },

  // clears any pending transactions
  clear: function () {
    localStorage.setItem(transactions._key, JSON.stringify([]));
  },
};

function promisesInSequence(promises) {
  var result = Promise.resolve();

  promises.forEach(function (promise) {
    result = result.then(promise);
  });

  return result;
}

function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function sendLog(logObject) {
  var url = "https://".concat(HEIMDALL_LOGGER_HOST, "/heimdall/log");
  var dataToSend = window.btoa(
    unescape(encodeURIComponent(JSON.stringify(logObject)))
  );

  url += "?log_data=" + encodeURIComponent(dataToSend);
  return fetch(url, { method: "GET", keepalive: true });
}

function sendAsync() {
  if (_sending) {
    if (_deferSendTimer) clearTimeout(_deferSendTimer);
    _deferSendTimer = setTimeout(sendAsync, 500);
    return;
  }

  var items = transactions.all();

  // if we have nothing to send, exit
  if (items.length === -1) return;

  _sending = true;

  if (_deferSendTimer) {
    clearTimeout(_deferSendTimer);
    _deferSendTimer = null;
  }

  var requests = items.map(function (item) {
    return function () {
      var itemToSend = cloneObject(item);
      return sendLog(itemToSend.eventBody)
        .then(function (respPromise) {
          item.__completed = true;
          return respPromise.text();
        })
        .then(function (response) {
        });
    };
  });

  promisesInSequence(requests)
    .then(function () {
      var completedRequests = items.filter(function (item) {
        return item.__completed;
      });
      transactions.remove(completedRequests);
      _sending = false;
    })
    .catch(function (logSendErr) {
      _sending = false;
    });
}

function checkIsShopifyRoute(path, pathsList) {
  if (pathsList.has(path)) {
    return true;
  }

  if (path.startsWith("/pages") && TECTONIC_ALLOWED_PAGES.has(path)) {
    return false
  }

  var pathsArr = Array.from(pathsList);
  for (let i = 0; i < pathsArr.length; i++) {
    var pathItem = pathsArr[i];
    if (path.startsWith(pathItem) || path.indexOf(pathItem) !== -1) {
      return true;
    }
  }
  return false;
}

function generateRedirectionUrl(
  ttResolvedDest,
  requestId,
  additionalUrlParams
) {
  var originalUrl = new URL(window.location.href);
  originalUrl.searchParams.delete('ttc');
  var originalUrlSearchParams = originalUrl.searchParams;
  var originHost = originalUrl.host;

  var redirectionHost =
    ttResolvedDest === AB_DEST_TECTONIC
      ? TECTONIC_SHOP_DOMAIN
      : SHOPIFY_SHOP_DOMAIN;

  var redirectionUrl = new URL(
    window.location.href.replace(originHost, redirectionHost)
  );

  Object.keys(additionalUrlParams || {}).forEach(function (key) {
    if (!isEmptyStr(additionalUrlParams[key])) {
      originalUrlSearchParams.append(key, additionalUrlParams[key]);
    }
  });

  if (requestId) {
    var finalQueryParams = "?".concat("request_id=", requestId);
    if (originalUrlSearchParams.size > 0) {
      finalQueryParams = finalQueryParams.concat(
        "&",
        originalUrlSearchParams.toString()
      );
    }
    redirectionUrl.search = finalQueryParams;
  }

  return redirectionUrl.toString();
}

function getOrCreateHermesDeviceId() {
  var deviceId = getCookie(TT_HERMES_DEVICE_ID_KEY);
  if (isEmptyStr(deviceId)) {
    deviceId = generateRandomId();
  }
  setCookie(TT_HERMES_DEVICE_ID_KEY, deviceId, 180);
  return deviceId;
}

function getSessionId() {
  var sessionId = getCookie(TT_CLIENT_SESSION_ID_KEY);
  if (isEmptyStr(sessionId)) {
    sessionId = generateRandomId();
  }
  setCookie(TT_CLIENT_SESSION_ID_KEY, sessionId, SESSION_ID_TTL_DAYS);
  return sessionId;
}

function getClientInstanceId() {
  var clientInstanceId = getCookie(TT_CLIENT_INSTANCE_ID_KEY);
  if (isEmptyStr(clientInstanceId)) {
    clientInstanceId = generateRandomId();
  }
  setCookie(TT_CLIENT_INSTANCE_ID_KEY, clientInstanceId);
  return clientInstanceId;
}

// [STICKINESS REMOVED] getCurrentSessionType / getCurrentSessionDestination /
// setCurrentSessionDestination were deleted. Instead, old sticky cookies are erased.
function clearLegacyStickyCookies() {
  var cleared = [];
  LEGACY_STICKY_COOKIES.forEach(function (name) {
    if (getCookie(name) !== null) {
      eraseCookie(name);
      cleared.push(name);
    }
  });
  return cleared;
}

try {
  window.addEventListener(window.cordova ? "deviceready" : "load", sendAsync, {
    passive: true,
  });
  window.addEventListener("online", sendAsync, { passive: true });
} catch (sendSetupErr) {
  console.error("[HEIMDALL_SEND_SETUP_ERR] ", sendSetupErr);
}

try {
  if (HEIMDALL_AB_CONFIG.CLEAR_LEGACY_STICKY_COOKIES) {
    logDetails["state"]["clearedLegacyCookies"] = clearLegacyStickyCookies();
  }
} catch (legacyCookieErr) {
  console.error("[HEIMDALL_LEGACY_COOKIE_CLEANUP_ERR] ", legacyCookieErr);
}

try {
  debugDestination =
    new URLSearchParams(currentUrlParams).get(TT_DEBUG_DEST_PARAM) || "";
} catch (debugDestErr) {
  console.error("[HEIMDALL_DEBUG_SETUP_ERR] ", debugDestErr);
}

try {
  var adminTesterQueryParams = new URLSearchParams(currentUrlParams);
  var adminTesterParam = adminTesterQueryParams.get(TT_HEIMDALL_ADMIN_TESTER_PARAM);
  var adminTesterStorage = localStorage.getItem(TT_HEIMDALL_ADMIN_TESTER_PARAM);
  isAdminTester = adminTesterParam === "true" || adminTesterStorage === "true";
  if (isAdminTester) {
    console.log("========================== HEIMDALL_ROUTER_ADMIN_TESTING_MODE_ACTIVATED ===============================")
    localStorage.setItem(TT_HEIMDALL_ADMIN_TESTER_PARAM, "true");
  }
} catch (adminTesterParamErr) {
  console.error("[HEIMDALL_DEBUG_SETUP_ERR] ", adminTesterParamErr);
}

try {
  var urlSearchParams = new URLSearchParams(currentUrlParams);
  isThemePreview =
    !isEmptyStr(
      urlSearchParams.get(SHOPIFY_THEME_EDITOR_PREVIEW_PARAM) ||
      urlSearchParams.get(SHOPIFY_THEME_PREVIEW_ID_PARAM) ||
      urlSearchParams.get(SHOPIFY_THEME_PREVIEW_KEY_PARAM) ||
      ""
    ) || window.location.href.indexOf(SHOPIFY_THEME_PREVIEW_HOST) !== -1;
} catch (previewParamErr) {
  console.error("[HEIMDALL_DEBUG_SETUP_ERR] ", previewParamErr);
}

try {
  var isB2BReferrer = document.referrer.indexOf("shopify") !== -1;
  if (isB2BReferrer) {
    setCookie(TT_SHOPIFY_B2B_REFERRER, document.referrer);
  } else {
    isB2BReferrer = !isEmptyStr(getCookie(TT_SHOPIFY_B2B_REFERRER));
  }
} catch (b2bReferrerCheckError) {
  console.error("[HEIMDALL_DEBUG_SETUP_ERR] ", b2bReferrerCheckError);
}

function getConnectionType() {
  var connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection ||
    {};
  return connection.effectiveType || connection.type || "";
}

try {
  globalProps["connectionType"] = getConnectionType();
  var connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;
  if (connection && connection.addEventListener) {
    connection.addEventListener("change", function () {
      globalProps["connectionType"] = getConnectionType();
    });
  }
} catch (connErr) {
  console.error("[HEIMDALL_SETUP_ERR] ", connErr);
}

function updateCart(updates, attributes) {
  var shouldUpdate = (updates && updates.length > 0) || (attributes && attributes.length > 0);

  if (shouldUpdate) {
    var formData = new FormData();

    updates.forEach((item) => {
      formData.append("updates[" + item["variantId"] + "]", item["quantity"]);
    });

    attributes.forEach((attr) => {
      formData.append("attributes[" + attr["key"] + "]", attr["value"]);
    })

    var host = window.shopifyRootHost.replace(/\/+$/, '');
    var url = host + '/cart/update.js'
    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return response.json();
      })
      .then((respJson) => {
        console.log("CART_SYNC_API_SUCCESS", respJson);
      })
      .catch((error) => {
        console.error("CART_SYNC_API_ERR", error);
      });
  } else {
    console.log("CART_SYNC_API_NO_OP");
  }
}

function sanitizeCartId(cartId) {
  if (isEmptyStr(cartId)) {
    return null
  }
  try {
    var parsedCartId = new URL(cartId)
    parsedCartId.searchParams.delete("key");
    return parsedCartId.toString();
  } catch (error) {
    return null
  }
}

var latestEncodedCart = null;
try {
  var toOverwriteCartParam =
    new URLSearchParams(currentUrlParams).get("ttc") || "";
  var latestCart = window.cartItems || {};

  var currentPromos = (window.cartPromos || []).filter((promo) => !isEmptyStr(promo))

  var CLEAR_CART_ATTR_PAYLOAD = [{"key": "tectonicSource", "value": ""}, {"key": "tectonicCartGeneratedID", "value": ""}, {"key": "tectonicCartId", "value": ""}]

  if (!isEmptyStr(toOverwriteCartParam)) {
    var toOverwriteCart = JSON.parse(atob(toOverwriteCartParam));
    var curentCartItems = window.cartItems || {};
    var remoteCartItems = toOverwriteCart["items"].reduce(
      (obj, item) =>
        Object.assign(obj, { [item["variantId"]]: item["quantity"] }),
      {}
    );
    var remoteCartAttributes = toOverwriteCart["attributes"]

    latestCart = remoteCartItems;

    var currentCart = Object.keys(curentCartItems),
      remoteCart = Object.keys(remoteCartItems);
    var allItems = new Set([].concat(currentCart, remoteCart));

    var updates = [];
    var isCartCleared = true;
    allItems.forEach((itemId) => {
      var itemCurrentCount = objGetOrDefault(curentCartItems, itemId)
      var itemRemoteCount = objGetOrDefault(remoteCartItems, itemId)
      if (itemRemoteCount == null) {
        updates.push({ variantId: itemId, quantity: 0 });
      } else if (itemRemoteCount != null && itemRemoteCount !== itemCurrentCount) {
        updates.push({ variantId: itemId, quantity: itemRemoteCount });
        isCartCleared = false;
      }
    });

    var attributes = [];
    if (updates.length > 0) {
      if (isCartCleared) {
        attributes = CLEAR_CART_ATTR_PAYLOAD
      } else {
        attributes = [
          {"key": "tectonicSource", "value": "tectonic"},
          {"key": "tectonicCartGeneratedID", "value": objGetOrDefault(remoteCartAttributes, "tectonicCartGeneratedID", "") || ""},
          {"key": "tectonicCartId", "value": sanitizeCartId(objGetOrDefault(remoteCartAttributes, "tectonicCartId", "")) || ""},
          {"key": "ttShopifyUserId", "value": getCookie(SHOPIFY_USER_TOKEN_NAME) || ""},
          {"key": "ttShopifySessionId", "value": getCookie(SHOPIFY_SESSION_TOKEN_NAME) || ""},
          {"key": "ttClientSessionId", "value": getCookie(TT_SESSION_ID_KEY) || ""}
        ]
      }
    }

    updateCart(updates, attributes)

  } else if (window.cartItems.length === 0 && objGetOrDefault(window.cartAttr, "tectonicSource") === "tectonic") {
    updateCart([], CLEAR_CART_ATTR_PAYLOAD)
  }

  var cartDataToSend = { items: [], attributes: {}, discountCodes: currentPromos };
  Object.keys(latestCart).forEach((itemId) => {
    cartDataToSend["items"].push({
      variantId: `${itemId}`,
      quantity: latestCart[itemId],
    });
  });
  latestEncodedCart = btoa(JSON.stringify(cartDataToSend));
} catch (cartSyncErr) {
  console.error("[HEIMDALL_CART_SYNC_ERR] ", cartSyncErr);
}

var requestId = generateRandomId();

try {
  var reqPath = window.location.pathname.replace(/\/$/, "").toLowerCase();

  var userAgent = window.navigator.userAgent;
  var sessionId = getSessionId();
  var deviceId = getOrCreateHermesDeviceId();
  var clientInstanceId = getClientInstanceId();
  var customerId = window.customerId || "";

  logDetails["input"] = {
    requestId: requestId,
    currentUrl: currentUrl,
    deviceId: deviceId,
    sessionId: sessionId,
    userAgent: userAgent,
    customerId: customerId,
    clientInstanceId: clientInstanceId,
    toOverwriteCart: toOverwriteCartParam,
    isAdminTester: isAdminTester,
    isABRoute: isABRoute,
    shopifySession: shopifySession,
    shopifyUser: shopifyUser,
  };

  var isDesktop = !checkIfMobile(userAgent);
  var isSocialBrowser = checkIfSocialBrowser(userAgent);
  var isBotReq = isBot(userAgent);

  var queryString = currentUrlParams;
  var queryParams = new URLSearchParams(queryString);
  var adQueryParams = [
    queryParams.get("tw_source"),
    queryParams.get("utm_source"),
    queryParams.get("utm_medium"),
    queryParams.get("utm_campaign"),
    queryParams.get("tw_adid"),
    queryParams.get("tw_campaign"),
    queryParams.get("fbclid"),
    queryParams.get("gclid"),
    queryParams.get("epik"),
    queryParams.get("ScCid"),
  ]
    .filter(function (data) {
      return !isEmptyStr(data);
    })
    .map(function (ad_param) {
      return ad_param.toLowerCase();
    });

  var isAdReq = adQueryParams.length > 0 || isSocialBrowser;

  var tectonicCustIdCookie = getCookie(CID_COOKIE_NAME);

  var shouldRouteAdsToShopify = HEIMDALL_AB_CONFIG.ROUTE_ADS_TO_SHOPIFY;
  var shouldRouteDesktopToShopify = HEIMDALL_AB_CONFIG.ROUTE_DESKTOP_TO_SHOPIFY;
  var shouldRouteBotsToShopify = HEIMDALL_AB_CONFIG.ROUTE_BOTS_TO_SHOPIFY;
  var isTestMode = HEIMDALL_AB_CONFIG.TEST_MODE;
  var isCutoverDone = HEIMDALL_AB_CONFIG.CUTOVER_DONE;

  Object.assign(logDetails["state"], {
    shouldRouteAdsToShopify: shouldRouteAdsToShopify,
    shouldRouteDesktopToShopify: shouldRouteDesktopToShopify,
    shouldRouteBotsToShopify: shouldRouteBotsToShopify,
    isTestMode: isTestMode,
    isCutoverDone: isCutoverDone,
    isB2BReferrer: isB2BReferrer,
    isAdReq: isAdReq,
    isSocialBrowser: isSocialBrowser,
    isBotReq: isBotReq,
    isDesktop: isDesktop,
    latestEncodedCart: latestEncodedCart,
  });

  var hasDebugDestination = AB_DESTS.has(debugDestination);
  logDetails["state"]["hasDebugDestination"] = hasDebugDestination;

  var isShopifyRoute = checkIsShopifyRoute(reqPath, SHOPIFY_ROUTES);
  logDetails["state"]["isShopifyRoute"] = isShopifyRoute;

  var isTestUser =
    (tectonicCustIdCookie && TEST_USERS_LIST.has(tectonicCustIdCookie)) ||
    false;

  logDetails["state"]["isTestUser"] = isTestUser;

  var shouldForceCurrReqToShopify =
    isB2BReferrer ||
    isShopifyRoute ||
    isThemePreview ||
    (shouldRouteBotsToShopify && isBotReq) ||
    (shouldRouteAdsToShopify && isAdReq) ||
    (shouldRouteDesktopToShopify && isDesktop);

  logDetails["state"]["shouldForceCurrReqToShopify"] =
    shouldForceCurrReqToShopify;

  var isABReq =
    (isAdminTester || !isTestMode) &&
    !shouldForceCurrReqToShopify &&
    !isTestUser &&
    !hasDebugDestination &&
    isABRoute;

  logDetails["output"]["isABReq"] = isABReq;

  var ttTempABDest = "";

  if (isTestMode || shouldForceCurrReqToShopify) {
    ttTempABDest = AB_DEST_SHOPIFY;
  }

  if (hasDebugDestination) {
    ttTempABDest = debugDestination;
  }

  logDetails["output"]["tempABDest"] = ttTempABDest;
  logDetails["output"]["isRegularReq"] = ttTempABDest === "";

  // ---------------------------------------------------------------------------
  // PER-PAGE A/B DECISION (no stickiness)
  // A fresh random draw on every page load. Nothing is read from or written to
  // cookies, so the previous page's destination has no influence on this one.
  // ---------------------------------------------------------------------------
  var ttDestThreshold = isAdReq
    ? HEIMDALL_AB_CONFIG.TT_AD_DEST_THRESH
    : HEIMDALL_AB_CONFIG.TT_DEST_THRESH;
  var ttDestProb = -1;
  var ttABDest = "";

  if (isABReq) {
    ttDestProb = Math.random();
    ttABDest = ttDestProb > ttDestThreshold ? AB_DEST_TECTONIC : AB_DEST_SHOPIFY;
  }

  logDetails["output"]["ttDestThreshold"] = ttDestThreshold;
  logDetails["output"]["ttDestProb"] = ttDestProb;
  logDetails["output"]["ttABDest"] = ttABDest;

  var ttResolvedDest = isABReq ? ttABDest : ttTempABDest;

  // Ensuring things to go tectonic once cutover is done
  // if (isABReq && isCutoverDone) {
  //   ttResolvedDest = AB_DEST_TECTONIC;
  // }

  ttResolvedDest = isShopifyRoute || isThemePreview ? AB_DEST_SHOPIFY : AB_DEST_TECTONIC

  logDetails["output"]["ttResolvedDest"] = ttResolvedDest;

  var additionalUrlParams = {};

  // if (ttResolvedDest === AB_DEST_TECTONIC) {
  //   additionalUrlParams = {
  //     "tthclid": btoa(JSON.stringify({
  //       "referrer": document.referrer,
  //       "session": shopifySession,
  //       "user": shopifyUser
  //     }))
  //   };
  //   if (!isEmptyStr(latestEncodedCart)) {
  //     additionalUrlParams["ttsc"] = latestEncodedCart;
  //   }
  // }

  var ttResolvedUrl = generateRedirectionUrl(
    ttResolvedDest,
    null, // requestId,
    additionalUrlParams
  );

  logDetails["output"]["ttResolvedUrl"] = ttResolvedUrl;

  execTime = Date.now() - startTime;

  // Request type is now computed per page load instead of being remembered in a cookie
  logDetails["output"]["requestType"] = !isABReq ? "TEMP" : (isAdReq ? "AD" : "DIRECT");

  console.log("TT_HEIMDALL_LOG", logDetails);
  if (ttResolvedDest === AB_DEST_TECTONIC) {
    sendImmediately = true;
    setCookie(TT_HEIMDALL_REFERRER, document.referrer || "", REFERRER_TTL_DAYS);
    window.location.replace(ttResolvedUrl);
  }
} catch (execErr) {
  console.error("[HEIMDALL_EXEC_ERR] ", execErr);
  heimdallErr = execErr.stack || execErr.message;
  isErrored = true;
} finally {
  try {
    Object.keys(globalProps).forEach(function (propName) {
      logDetails["input"][propName] = globalProps[propName];
    });

    logDetails["input"]["encodedUrl"] = window.btoa(currentUrl);

    var logBody = {
      heimdall: logDetails,
      client: {
        url: currentUrl,
        _time: Date.now(),
        execStatus: isErrored ? "FAILED" : "SUCCESS",
        execTime: execTime,
        error: heimdallErr,
      },
    };

    if (sendImmediately) {
      sendLog(logBody);
    } else {
      transactions.add({ eventBody: logBody });
      sendAsync();
    }
  } catch (sendErr) {
    console.error("[HEIMDALL_SEND_ERR] ", sendErr);
  }
}